module.exports = __webpack_public_path__ + "img/icon3.1fb7cbc9.jpg";